import { Injectable } from '@angular/core';
import { ApiService, AppSettingsService } from '@woolworthsnz/styleguide';
import {
	AccountDetailsResponse,
	ShopperSettingsResponse,
	UpdateCredentialsRequest,
	UpdatePersonalDetailsRequest,
	UpdateShopperSettingsRequest,
} from '@woolworthsnz/trader-api';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class AccountService {
	constructor(private apiService: ApiService, private appSettingsService: AppSettingsService) {}

	myDetails(): Observable<AccountDetailsResponse> {
		return this.apiService.get(`${this.appSettingsService.getEndpoint('myAccountDetails')}`);
	}

	updatePersonalDetails(request: UpdatePersonalDetailsRequest): Observable<void> {
		return this.apiService.put(`${this.appSettingsService.getEndpoint('myAccountDetails')}`, request);
	}

	updateCredentials(request: UpdateCredentialsRequest): Observable<void> {
		return this.apiService.patch(`${this.appSettingsService.getEndpoint('myAccountCredentials')}`, request);
	}

	myPreferences(): Observable<ShopperSettingsResponse> {
		return this.apiService.get(this.appSettingsService.getEndpoint('mySettings'));
	}

	updatePreferences(request: UpdateShopperSettingsRequest): Observable<void> {
		/* First getting the latest preferences to avoid accidentally overwriting them */
		return this.myPreferences().pipe(
			switchMap((oldPreferences) => {
				const mealPlanning = {
					preferences: { ...oldPreferences.mealPlanning?.preferences, ...request.mealPlanning?.preferences },
				};

				const preferences = {
					...oldPreferences,
					...request,
					...(!!request.mealPlanning && { mealPlanning }),
				};

				return this.apiService.put(`${this.appSettingsService.getEndpoint('mySettings')}`, { ...preferences });
			})
		);
	}
}
